import styled from 'styled-components';

const TcooContendor = styled.div`
  padding-top: 10px;
  text-align: center;
.InputCoordinateCard__error-message{
    color: #BF0238;
    font-size: 11px;
    font-weight: 400;
}
button.HelperError__btn-retry {
    color: #BF0238;
    font-size: 11px;
    font-weight: bold;
}
    .factor p {
        color: #333333;
        font-size: 14px;
        font-weight: 400 !important;
        line-height: 18px;
    }
    .factor p strong{
        font-size: 14px;
        color: var(--red-coopeuch)
    }
    .ClockHelper .ClockHelper__label img {
        height: 11px;
    }
    .progress-btn {
        position: relative;
        width: 172px;
        height: 40px;
        display: inline-block;
        background: #007DB7;
        box-shadow: 0 0 8px 0 rgb(0 0 0 / 14%);
        color: #fff;
        font-weight: normal;
        font-size: 20px;
        transition: all 0.4s ease;
        border-radius: 24px;
        margin-top: 21px;
    }

    .progress-btn:not(.active) {
        cursor: pointer;
    }
    form.InputCoordinateCard__form.InputCoordinateCard__form--error input {
        border-color: #BF0238 !important;
    }
    .Input.Input--disabled label{
        color: #333333;
        font-weight: bold;
    }
    .Input__label-wrapper label {
        position: relative;
        color: #333333;
        font-weight: bold;
    }
    .ClockHelper.ClockHelper--is-time-up span {
        color: #E4002B;
    }
    button.ClockHelper__btn-retry {
        color: #E4002B;
        font-weight: bold;
    }
    .button-generar-tcoo.progress-btn .btn {
        font-size: 14px;
    }
    .progress-btn .btn {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        line-height: 39px;
        text-align: center;
        z-index: 10;
        opacity: 1;
        
    }
    span.tiempo-pass-coopeuch {
        color: #646569a3;
        font-size: 12px;
        display: flex;
        margin-top: 14px;
    }
    span.tiempo-pass-coopeuch strong {
      font-size: 12px;
    }
    span.tiempo-pass-coopeuch img {
        display: inline-block;
        vertical-align: baseline;
        margin-right: 5px;
    }
    .factor p:nth-child(2) {
        font-size: 13px;
    }
    .progress-btn .progress {
        width: 0%;
        z-index: 5;
        height: 40px;
        background: #f6f3f56e;
        opacity: 0;
        transition: all 0.3s ease;
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
    }
    .progress-btn.active .progress {
        opacity: 1;
        animation: progress-anim 10s ease 0s;
    }
    @keyframes progress-anim {
        0% {
            width: 0%;
        }
        5% {
            width: 0%;
        }
        10% {
            width: 15%;
        }
        30% {
            width: 40%;
        }
        50% {
            width: 55%;
        }
        80% {
            width: 100%;
        }
        95% {
            width: 100%;
        }
        100% {
            width: 0%;
        }
    }
  
    .input-success {
      input,.Input.Input--normal.Input--focused input {
        border-color: #0E891A;
      }

      span.tiempo-pass-coopeuch {
        color: #0E891A;
      }

      .InputCoordinateCard__countdown {
        display: none;
      }
    }

    @media (max-width: 426px){
        .factor p {
            font-size: 12px !important;
        }
        span.tiempo-pass-coopeuch {
            font-size: 11px !important;
        }
        span.tiempo-pass-coopeuch strong {
            font-size: 11px !important;
        }
        .InputCoordinateCard .InputCoordinateCard__input-group {
            column-gap: 0 !important;
        }
        .factor p:nth-child(2) {
            font-size: 13px;
        }
        .factor p strong {
            font-size: 13px;
        }
        .progress-btn {
            width: 160px;
        }
        .button-generar-tcoo.progress-btn .btn {
            font-size: 13px;
        }
        .Input.Input--normal input {
            width: 65px;
        }
        .Input__label-wrapper label{
            font-size: 13px;
        }
        ClockHelper__complementary-text p {
            font-size: 11px !important;
        }
        .ClockHelper__time span {
            font-size: 11px !important;
        }
    }

    @media (max-width: 376px){
        .factor p {
            font-size: 11px !important;
        }
        .box.btn-autorizar {
            margin: 0 28px;
        }
        button.Button.Button--complementary {
            font-size: 12px !important;
        }
        .factor p{
            font-size: 11px;
        }
        span.tiempo-pass-coopeuch {
            font-size: 10px !important;
        }
        span.tiempo-pass-coopeuch strong {
            font-size: 10px !important;
        }
        .InputCoordinateCard .InputCoordinateCard__input-group {
            column-gap: 0 !important;
        }
        .factor p:nth-child(2) {
            font-size: 12px;
        }
        .factor p strong {
            font-size: 12px;
        }
        .progress-btn {
            width: 158px;
        }
        .button-generar-tcoo.progress-btn .btn {
            font-size: 12px;
        }
        .Input.Input--normal input {
            width: 65px;
        }
        .Input__label-wrapper label{
            font-size: 12px;
        }
        ClockHelper__complementary-text p {
            font-size: 9px !important;
        }
        .ClockHelper__time span {
            font-size: 9px !important;
        }
    }

    @media (max-width: 321px){
        .factor p {
            font-size: 10px !important;
        }
        .box.btn-autorizar {
            margin: 0 28px;
        }
        button.Button.Button--complementary {
            font-size: 12px !important;
        }
        .factor p{
            font-size: 11px;
        }
        span.tiempo-pass-coopeuch {
            font-size: 10px !important;
        }
        span.tiempo-pass-coopeuch strong {
            font-size: 10px !important;
        }
        .InputCoordinateCard .InputCoordinateCard__input-group {
            column-gap: 0 !important;
        }
        .factor p:nth-child(2) {
            font-size: 12px;
        }
        .factor p strong {
            font-size: 12px;
        }
        .progress-btn {
            width: 72%;
        }
        .button-generar-tcoo.progress-btn .btn {
            font-size: 12px;
        }
        .Input.Input--normal input {
            width: 65px !important;
            height: 42px; !important;
        }
        .Input__label-wrapper label{
            font-size: 12px;
        }

        ClockHelper__complementary-text p {
            font-size: 10px !important;
        }
        .ClockHelper__time span {
            font-size: 10px !important;
        }
        .ClockHelper.ClockHelper--is-time-up span {
            font-size: 10px !important;
        }
        button.ClockHelper__btn-retry {
            font-size: 10px !important;
        }
        p.ClockHelper__complementary-text span {
            font-size: 10px !important;
        }
    }
    
`;

export default TcooContendor;